import apiAxiosClient from './apiAxiosClient';

const placeApi = {
    getAll(params) {
        const url = '/api/place/all';
        return apiAxiosClient.post(url, params);
    },
    insert(params) {
        const url = '/api/place/insert';
        return apiAxiosClient.post(url, params);
    },
    update(params) {
        const url = '/api/place/update';
        return apiAxiosClient.post(url, params);
    },
    delete(params) {
        const url = '/api/place/delete';
        return apiAxiosClient.post(url, params);
    },
};

export default placeApi;
